import * as React from 'react'

import Svg, { Circle, ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CreditCardOptions = ({
  size = 40,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <Circle cx={20} cy={20} r={20} fill="#fff" />
    <G clipPath="url(#a)" fill={color}>
      <Path d="M31.25 23.143c-.414 0-.75.352-.75.785v5.5h-21V20h8.25c.414 0 .75-.352.75-.786 0-.434-.336-.786-.75-.786H9.5v-3.143h8.25c.414 0 .75-.352.75-.785 0-.434-.336-.786-.75-.786H9.5c-.828 0-1.5.704-1.5 1.571v14.143C8 30.296 8.672 31 9.5 31h21c.828 0 1.5-.704 1.5-1.572v-5.5c0-.433-.336-.785-.75-.785Z" />
      <Path d="M14.75 23.143h-3c-.414 0-.75.352-.75.785 0 .434.336.786.75.786h3c.414 0 .75-.352.75-.786 0-.433-.336-.785-.75-.785ZM20.75 23.143h-3c-.414 0-.75.352-.75.785 0 .434.336.786.75.786h3c.414 0 .75-.352.75-.786 0-.433-.336-.785-.75-.785ZM31.545 11.42l-5.25-2.358a.732.732 0 0 0-.592 0l-5.25 2.358a.79.79 0 0 0-.453.722v3.143c0 4.323 1.525 6.85 5.626 9.325a.725.725 0 0 0 .748 0c4.1-2.468 5.626-4.995 5.626-9.325v-3.143a.788.788 0 0 0-.455-.722ZM30.5 15.285c0 3.629-1.146 5.626-4.5 7.732-3.354-2.11-4.5-4.108-4.5-7.732v-2.624l4.5-2.02 4.5 2.02v2.624Z" />
      <Path d="M28.72 13.885a.732.732 0 0 0-1.055.123l-2.358 3.09-.932-1.462a.731.731 0 0 0-1.04-.218.81.81 0 0 0-.209 1.089l1.5 2.357a.75.75 0 0 0 .593.35h.031a.738.738 0 0 0 .587-.295l3-3.929a.812.812 0 0 0-.117-1.105Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(8 9)" d="M0 0h24v22H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CreditCardOptions
